import React, { useState, useEffect, useMemo, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import style from './NoticeDetail.module.css';
import HeadSub from '../../../../components/comm/HeadSub';
import URL from "../../../../constants/url";
import axiosApi from '../../../../api/daonAxios';
import CODE from '../../../../constants/code';
import Modal from '../../../../components/comm/Modal';


const NoticeDetail = () => {

  const location = useLocation();
  const navigate = useNavigate();

  const [modalOpen, setModalOpen] = useState(false);  //모달창
  const [modalMessage, setModalMessage] = useState(''); //모달 메세지

  const closeModal = () => {
      setModalOpen(false);
  }

  const {
    hospCd = "",
    notiTl = " ",
    notiCnt = " ",
    notiCont = "",
    notiDate = "",
    noticeList: initialNoticeList = [],
    currentIndex: initialIndex = 0,
    initialPageNo = 1,
    isLastPage: initialIsLastPage = false,   // 추가
  } = location.state || {};


  //이미지 가져오기 도메인 설정
    const domainUrl = {
        "012": { url: "https://www.cmcseoul.or.kr" },
        "011": { url: "https://www.cmcsungmo.or.kr" },
        "015": { url: "https://www.cmcep.or.kr" },
        "013": { url: "https://www.cmcujb.or.kr" },
        "014": { url: "https://www.cmcbucheon.or.kr" },
        // "016": { url: "인천성모병원" },
        // "018": { url: "대전성모병원" },
};

  // hospCd 기반 도메인 가져오기
  const domainPrefix = useMemo(() => {
  return domainUrl[hospCd] || { url: '' };
}, [hospCd]);


  // 이미지 경로 수정 함수도 hospCd에 따라 동작하도록 변경
  const fixImageSrc = (html) => {

    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;

    // 이미지 src 수정
    const imgs = tempDiv.querySelectorAll('img');
    imgs.forEach(img => {
      const src = img.getAttribute('src');
      if (src && src.startsWith('/')) {
        img.setAttribute('src', domainPrefix.url + src);
      }
    });

    // iframe 래핑 처리
    const iframes = tempDiv.querySelectorAll('iframe');
    iframes.forEach(iframe => {
      const wrapper = document.createElement('div');
      wrapper.className = 'iframe-wrap';
      iframe.parentNode.insertBefore(wrapper, iframe);
      wrapper.appendChild(iframe);
    });

    // 최상위 table만 감싸기
    const tables = tempDiv.querySelectorAll('table');

    tables.forEach(table => {
      // 상위에 table이 있는지 검사
      let isNested = false;
      let parent = table.parentElement;
      while (parent) {
        if (parent.tagName.toLowerCase() === 'table') {
          isNested = true;
          break;
        }
        parent = parent.parentElement;
      }
      if (isNested) return;

      //태그 추가 
      const scrollBox = document.createElement('div');
      scrollBox.className = style['scroll-box'];

      const scrollNotice = document.createElement('p');
      scrollNotice.className = style['scroll-icon-box'];
      scrollNotice.textContent = '※ 좌우로 스크롤 하세요';

      const tableBox = document.createElement('div');
      tableBox.className = style['table-box']; 

      table.parentNode.insertBefore(tableBox, table);
      scrollBox.appendChild(table);
      tableBox.appendChild(scrollNotice);
      tableBox.appendChild(scrollBox);
    });

    const links = tempDiv.querySelectorAll('a[href]');
      links.forEach(link => {
      link.setAttribute('target', '_blank'); // 새 창으로
      link.setAttribute('rel', 'noopener noreferrer');
    });

    return tempDiv.innerHTML;
  };


  const [noticeList, setNoticeList] = useState(initialNoticeList);
  const [currentIndex, setCurrentIndex] = useState(initialIndex);
  const [pageNo, setPageNo] = useState(initialPageNo);
  const [isLoading, setIsLoading] = useState(false);
  const [pendingIndex, setPendingIndex] = useState(null); // 다음 글 인덱스 대기 상태
  const [isLastPage, setIsLastPage] = useState(initialIsLastPage); //  동기화

  useEffect(() => {
    if (!hospCd) {
        console.error('Missing hospCd!');
    }
    }, [hospCd]);

  // 현재 보여줄 공지 (현재 인덱스 기반)
  const currentNotice = noticeList[currentIndex] || {};
  const processedHtml = fixImageSrc(currentNotice.content || "");
  
  const lastLoadedNoticesRef = useRef([]);
  
  // 다음 페이지 데이터 불러오기 함수
  const loadNextPage = async () => {

    setIsLoading(true);
      try {
        const url = "/guide/board/retrieveBoardList";
        const params = {
          hsptlCd: hospCd,
          boardCd: "notice",
          pageNo: String(pageNo + 1),
          keyword: ""
        };
        const res = await axiosApi.post(url, params);
        
        if (res.data.resultCode === CODE.RCV_SUCCESS) {
          const notiBundle = res.data.result.faqInfo;
          const parsed = JSON.parse(notiBundle);

          if (parsed.length === 0) {
            setIsLastPage(true); 
            return false;
          }

          if (parsed.length < 10) {
            setIsLastPage(true);
          }

          lastLoadedNoticesRef.current = parsed;
          setPageNo((prev) => prev + 1);
          return true;
        }
        return false;
      } catch (e) {
        console.error(e);
        return false;
      } finally {
        setIsLoading(false);
      }
    };


  const goToNotice = async (newIndex) => {
     // 이전글/다음글 없는 경우 모달 띄우기
    if (newIndex < 0) {
      setModalMessage('다음 글이 없습니다.');
      setModalOpen(true);
      return;
    }
    // 다음글 없는 경우
    if (isLastPage && newIndex >= noticeList.length) {
      setModalMessage('이전 글이 없습니다.');
      setModalOpen(true);
      return;
    }

    // 이미 로드된 공지라면 바로 이동
    if (newIndex >= 0 && newIndex < noticeList.length) {
      navigateToIndex(newIndex);
      return;
    }

    
    // 다음 페이지 로드 (다음 글일 때만)
    if (newIndex >= noticeList.length) {
      const success = await loadNextPage();
      if (!success) return;

      const updatedList = [...noticeList, ...lastLoadedNoticesRef.current];
      setNoticeList(updatedList);

      if (newIndex < updatedList.length) {
        navigateToIndex(newIndex, updatedList);
      }
    }
  };

const navigateToIndex = (index, list = noticeList) => {
  setCurrentIndex(index);
  navigate(location.pathname, {
    state: {
      hospCd,
      notiTl: list[index].title,
      notiCnt: list[index].readCnt,
      notiCont: list[index].content,
      notiDate: list[index].createdDt,
      noticeList: list,
      currentIndex: index,
      initialPageNo: pageNo,
    },
  });
};

  
  useEffect(() => {
    if (pendingIndex !== null && pendingIndex < noticeList.length) {
      setCurrentIndex(pendingIndex);
      navigate(location.pathname, {
        state: {
            hospCd:hospCd,
            notiTl: noticeList[pendingIndex].title,
            notiCnt: noticeList[pendingIndex].readCnt,
            notiCont: noticeList[pendingIndex].content,
            notiDate: noticeList[pendingIndex].createdDt,
            noticeList,
            currentIndex: pendingIndex,
            initialPageNo: pageNo,
        }
      });
      setPendingIndex(null);
    }
  }, [pendingIndex, noticeList, navigate, location.pathname, pageNo]);


  //뒤로가기 
  const handleBackClick = () => {
      navigate(URL.HOSPITAL_NOTICELISTS, {
          replace: true,
          state: { hsptlCd: hospCd },
          });
  };

  return (
    <>
      <HeadSub title="상세보기" onBack={handleBackClick}/>

      <div id="sub-content" data-layout="white">
        <div className="inner-wrap">
          <div className={style['notice-detail-box']}>
            <div className={style['head']}>
              <p className={style['title']}>{currentNotice.title || notiTl}</p>
              <p className={style['bot-box']}>
                <span>{new Date(notiDate).toLocaleDateString('ko-KR', {year:'numeric',month:'2-digit',day:'2-digit' }).replace(/\.$/, '')}</span> 
                <span>조회수 {currentNotice.readCnt || notiCnt}</span>
              </p>
            </div>

            <div className={style['mid']}>
              <div
                className={style['content']}
                dangerouslySetInnerHTML={{ __html: processedHtml }}
              />
            </div>
          </div>

          <div className="bottom-fixed-box" data-border-line="top">
            <div className="inner-box">
              <div className="btn-layout" data-btn-num="2">
                <button
                  className="btn"
                  data-btn-type="fill-gray"
                  data-btn-size="lg"
                  data-btn-icon="prev"
                  onClick={() => goToNotice(currentIndex + 1)}
                  //disabled={isLoading || (currentIndex >= noticeList.length - 1 && isLastPage)}
                  disabled={isLoading}  // 이전처럼 리스트 끝일때 disable 제거
                >
                  <span>이전 글</span>
                </button>
                <button
                  className="btn"
                  data-btn-type="fill-gray"
                  data-btn-size="lg"
                  data-btn-icon="next"
                  onClick={() => goToNotice(currentIndex - 1)}
                  //disabled={currentIndex <= 0}
                  disabled={isLoading} // 다음 글 버튼도 동일
                >
                  <span>다음 글</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal isOpen={modalOpen} setIsOpen={setModalOpen} >
          <div className='modal-box' data-type="a">
              <div className='modal-top-box'>
                  <div className='title-box'>
                      <p>{modalMessage}</p>
                  </div>
              </div>

              <div className="modal-bottom-box"> 
                  <div className='btn-layout'>
                      <button className="btn" data-btn-type="fill-main" data-btn-size="md" onClick={closeModal}>
                          <span>확인</span>
                      </button>
                  </div>
              </div>
          </div>
      </Modal>
    </>
  );
};

export default NoticeDetail;
